'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dError$002dPayload from "./presto.types$-Two-Factor-Auth-Error-Payload.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthErrorPayload$() {
}
export { $c_Lpresto_types$TwoFactorAuthErrorPayload$ as $c_Lpresto_types$TwoFactorAuthErrorPayload$ };
$p = $c_Lpresto_types$TwoFactorAuthErrorPayload$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthErrorPayload$;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthErrorPayload$() {
}
export { $h_Lpresto_types$TwoFactorAuthErrorPayload$ as $h_Lpresto_types$TwoFactorAuthErrorPayload$ };
$h_Lpresto_types$TwoFactorAuthErrorPayload$.prototype = $p;
$p.l = (function() {
  return "TwoFactorAuthErrorPayload";
});
$p.cG4 = (function(x$0) {
  return new $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dError$002dPayload.$c_Lpresto_types$TwoFactorAuthErrorPayload(x$0.j(0));
});
var $d_Lpresto_types$TwoFactorAuthErrorPayload$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthErrorPayload$, "presto.types$TwoFactorAuthErrorPayload$", ({
  a2C: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$TwoFactorAuthErrorPayload$ as $d_Lpresto_types$TwoFactorAuthErrorPayload$ };
var $n_Lpresto_types$TwoFactorAuthErrorPayload$;
function $m_Lpresto_types$TwoFactorAuthErrorPayload$() {
  if ((!$n_Lpresto_types$TwoFactorAuthErrorPayload$)) {
    $n_Lpresto_types$TwoFactorAuthErrorPayload$ = new $c_Lpresto_types$TwoFactorAuthErrorPayload$();
  }
  return $n_Lpresto_types$TwoFactorAuthErrorPayload$;
}
export { $m_Lpresto_types$TwoFactorAuthErrorPayload$ as $m_Lpresto_types$TwoFactorAuthErrorPayload$ };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Error-Payload$.js.map
